export default "__VITE_ASSET__BH3B_chV__"